<script lang="ts">

  import { page } from "$app/state"
  import httpClient from "$lib/axios-client"
  import {
    AlertDialog,
    AlertDialogAction,
    AlertDialogCancel,
    AlertDialogContent,
    AlertDialogDescription,
    AlertDialogFooter,
    AlertDialogHeader,
    AlertDialogTitle
  } from "$lib/components/ui/alert-dialog"
  import { type _response } from "$lib/data/type/_response"
  import LoaderCircleIcon from "@lucide/svelte/icons/loader-circle"
  import { createMutation, useQueryClient } from "@tanstack/svelte-query"
  import { toast } from "svelte-sonner"

  const { open, setOpen, select }: {
    open: boolean
    setOpen: (value: boolean) => void
    select: string
  } = $props()

  const prefix = $derived(page.params.prefix ?? "0")

  const queryClient = useQueryClient()

  const mutation = createMutation(() => ({
    mutationFn: async () => {

      const response = await httpClient.delete<_response<null>>(`/api/${prefix}/order/data/${select}`)
      const responseData = response.data!

      if (response.status != 200) {
        throw new Error(responseData.message)
      }

      void await queryClient.invalidateQueries({ queryKey: ["order-outstanding"] })
      void await queryClient.invalidateQueries({ queryKey: ["order-outstanding-dash"] })
      toast.success(responseData.message)

      setOpen(false)
    },
    onError: (error: Error) => {
      toast.error("Terjadi kesalahan", {
        description: error.message
      })
    }
  }))

</script>
<AlertDialog
  open={open}
  onOpenChange={setOpen}>
  <AlertDialogContent class="w-xs">
    <AlertDialogHeader>
      <AlertDialogTitle>Hapus</AlertDialogTitle>
      <AlertDialogDescription>
        Konfirmasi hapus data ini
      </AlertDialogDescription>
    </AlertDialogHeader>
    <AlertDialogFooter>
      <AlertDialogCancel
        disabled={mutation.isPending}>
        Batal
      </AlertDialogCancel>
      <AlertDialogAction
        class="group"
        data-loading={mutation.isPending}
        disabled={mutation.isPending}
        onclick={(event) => {
          event.preventDefault()
          mutation.mutate()
        }}>
        <span class="group-data-[loading=true]:invisible">Hapus</span>
        <LoaderCircleIcon class="group-data-[loading=true]:visible invisible absolute animate-spin"/>
      </AlertDialogAction>
    </AlertDialogFooter>
  </AlertDialogContent>
</AlertDialog>
